export const DATE_FORMAT = "yyyy-MM-dd";
export const PLACEHOLDER_DATE_FORMAT = "yyyy-mm-dd";
export const APPOINTMENT_DATE_FORMAT = "yyyy/MM/dd";
export const DATE_TIME_FORMAT = "yyyy-MM-dd hh:mm:ss";
export const TIME_FORMAT = "HH:mm:ss";

export const DATE_INPUT_PLACEHOLDER = " 年　/ 月　/ 日";

export const FIRST_PAGE = 1;

export const SEARCH_STEPS = {
  SEARCH: 1,
  FEATURE: 2,
  MAP: 3,
};

export const PRICE_DEFAULT = {
  MIN: 800,
  MAX: 3000,
};
export const FOOTER_HEIGHT = 56;
export const MESSAGE_CONTROL_HEIGHT = 34;
export const APP_BAR_HEIGHT = 82;

export const MAX_JOB_APPLY = 9;
export const MAX_JOB_RESULT_EMPLOY = 9;
export const ADOPT_FLAG_KEYS = {
  APPLY: 0,
  APPROVED: 1,
  REJECTED: 2,
};

export const ADOPT_FLAGS = {
  0: {
    name: "応募中",
    color: "#29AFE6",
  },
  1: {
    name: "採用",
    color: "#FF8213",
  },
  2: {
    name: "不採用",
    color: "#848B8C",
  },
};

export const JOB_DETAIL = {
  SHORT_NOTE_LENGTH: 250,
};

export const MESSAGE_TABS = {
  message: { id: 1, title: "メッセージ", name: "message", unread: null },
  news: { id: 2, title: "ニュース", name: "notify", unread: null },
};

export const NEW_MESSAGE_TYPES = {
  message: 1,
  news: 2,
};
export const ACTIVE_TAB_BG_COLOR = "#2BAFE6";

export const SHIFT_PATTERN_LIST = [
  { id: 1, name: "日勤" },
  { id: 2, name: "夜勤" },
  { id: 3, name: "早朝" },
  { id: 4, name: "午前" },
  { id: 5, name: "午後" },
  { id: 6, name: "夕勤" },
  { id: 7, name: "その他" },
];

export const STEPPER_STAFF_STATUS = {
  APPOINTMENT: 1,
  REGISTER: 1,
  REGISTER_FOREIGN: 1,
  OFFICIAL_REGIST: 2,
  VIDEO: 3,
  IMAGE_REGIST: 2,
};

export const REGEX = {
  NUMBER: /^[0-9]+$/,
  DATE_INPUT: /([0-9]|\/+$)/,
  DATE_FORMAT: /^((\d{4})(\/|-)([1-9]|1[0-2]|0[1-9])(\/|-)(0[1-9]|[1-9]|[1-2][0-9]|3[0-1]))$/,
  URL: /(https?:\/\/[^\s]+)/g,
};
export const MAX_LENGTH_DATE_INPUT = {
  DEFAULT: 20,
  DATE: 10,
};

export const COMPARE_CONFIRM_TIME_INDEX = 9;

export const MAX_UPLOAD_IMAGE_SIZE = 5242880; // 5Mb

export const STEPS_JOB_WORK = [
  {
    key: "has_departed",
    active_key: "can_departure",
    value: 0,
    label: "出発打刻",
  },
  {
    key: "has_arrived",
    active_key: "can_arrive",
    value: 1,
    label: "到着打刻",
  },
  {
    key: "has_attended",
    active_key: "can_attend",
    value: 2,
    label: "点呼報告",
  },
  {
    key: "has_reported",
    active_key: "can_closing_report",
    value: 3,
    label: "終了報告",
  },
];

export const BUTTON_JOBS_WORK = {
  can_departure: "出発打刻をする",
  can_arrive: "到着打刻をする",
  can_closing_report: "終了報告をする",
  can_attend: "点呼報告をする",
};
export const MAX_UPLOAD_DOCUMENT_NUMBER = 5;
export const MAX_UPLOAD_IMAGE_REGIST_NUMBER = 3;
export const MAX_UPLOAD_MYNO_NUMBER = 2;

export const INIT_ROTATE_DEG = 0;

export const PAYMENT_WAYS = {
  MONTHLY: 1,
  WEEKLY: 2,
  HAND_DELIVERY: 3,
};

export const STEPS = {
  REGISTER: ["面談予約", "<p>プロフィール<br/>入力</p>"],
  OFFICIAL_REGISTER: ["面談予約", "<p>プロフィール<br/>入力</p>"],
};

export const KEYS_NAME = {
  BACKSPACE: "Backspace",
  ARROW_LEFT: "ArrowLeft",
  ARROW_RIGHT: "ArrowRight",
  ARROW_TOP: "ArrowTop",
  ARROW_BOTTOM: "ArrowBottom",
  DELETE: "Delete",
  TAB: "Tab",
};

export const CHECK_KEY_LIST = Object.keys(KEYS_NAME).map((key) => KEYS_NAME[key]);

export const MIN_REGIST_AGE = 16;

export const MAX_LENGTH_RELOAD = 10;

export const MAX_DAY_JOB_RESULT = 59;

export const HEADER_HEIGHT = 56;

export const IS_PREMIUM = 4;
export const ADOPT_FLAG_CANCEL = 9;
export const BACK_URL_VALUE = -1;
export const OTHER_CONSENT_RELATION_ID = 9;
export const RESPONSE_ACCEPTS = {
  ERRORS: ["ERR_BAD_REQUEST"],
};

export const CHECK_BOX_VALUES = {
  CHECKED: 1,
  NOT_CHECKED: 0,
};

export const MAX_LENGTH_MYNO_NUMBER = 12;

export const RANGE_DATE_DEFAULT = 14; // two weeks

export const JOB_TYPES = {
  MESSAGE: "message",
  SUGGEST: "suggest",
  MAP: "map",
  WISHLIST: "wishlist",
};

export const JOBDETAIL_TYPES_REFETCH = [JOB_TYPES.MESSAGE, JOB_TYPES.SUGGEST];
export const STATUS_CODES = {
  NOT_FOUND: 404,
  HTTP_SERVICE_UNAVAILABLE: 503,
};

export const SPECIAL_ACTIVITY_VISA = [25, 26];

export const EXPERIENCES_DATA_LENGTH = 3;

export const initExperiencesPayload = {
  experience_1: {},
  experience_2: {},
  experience_3: {},
};

export const NOT_VALUE_OPTION_ID = 0;

export const STATUS_RESIDENCE_TYPE = [undefined, -1, null];

export const EMAIL_LABEL_COMPANY = {
  FIRST_MAIL: "営業一課E-MAIL：",
  SECOND_MAIL: "営業二課E-MAIL：",
};
export const START_SLICE_NUM = 0;

export const LIMIT_ITEM_PAGE = 10;
export const ERROR_CODE_PUSH_NOTIFICATION = {
  SYSTEM: 0,
  INCOGNITO_MODE: 20,
};

export const DEFAULT_DATE = "2022-01-01T";

export const ICON_EVALUATIONS = {
  1: "/img/icons/evaluations/1.png",
  2: "/img/icons/evaluations/2.png",
  3: "/img/icons/evaluations/3.png",
  4: "/img/icons/evaluations/4.png",
  5: "/img/icons/evaluations/5.png",
  6: "/img/icons/evaluations/6.png",
  7: "/img/icons/evaluations/7.png",
  8: "/img/icons/evaluations/8.png",
  9: "/img/icons/evaluations/9.png",
  10: "/img/icons/evaluations/10.png",
};

export const MOVE_TO = {
  EVALUATION: "evaluation",
};

export const SHIFT_TYPE = {
  SHIFT_SUBMITTED: 1,
  WORK_WITHOUT_SHIFT: 2,
  WORK_WITH_SHIFT: 3,
};

export const SHIFT_TYPE_COLOR = {
  0: "#E03C3D",
  6: "#1478BA",
};

export const DAY_OF_WEEK = ["日", "月", "火", "水", "木", "金", "土"];

export const SHIFT_TYPE_ICON = {
  99: "/img/icons/not-in-month.png", // Default icon for days not in month
  0: "/img/icons/not-working-day.png", // Default icon for days without status
  1: "/img/icons/shift-submitted.png", // Icon "シフト提出済"
  2: "/img/icons/working-without-shift.png", // Icon "出勤" without shift
  3: "/img/icons/working-with-shift.png", // Icon "出勤" with submitted shift
};
